import { t } from "@/i18n-js/instance";
import { useCurrentCommunityContext } from "@circle-react/apps/AuthenticationApp";
import { BaseRedirectLinkContainer } from "@circle-react/components/OnboardingComponents/BaseRedirectLinkContainer";
import { useResendOtp } from "@circle-react/hooks/useResendOtp";
import { Button } from "@circle-react-uikit/Button";

interface CurrentCommunityContextType {
  userEmail: string;
}

function toCurrentCommunityContext(obj: any): CurrentCommunityContextType {
  return obj;
}
export const ResendOtpLink = () => {
  const result = toCurrentCommunityContext(useCurrentCommunityContext());
  const { userEmail } = result;
  const { mutateAsync: handleClick, isLoading } = useResendOtp({});

  return (
    <BaseRedirectLinkContainer>
      {t("authentication_app.shared_links.resent_otp_code.prefix")}{" "}
      <Button
        variant="text"
        onClick={async event => {
          event.preventDefault();
          await handleClick({ user: { email: userEmail } });
        }}
        className="!text-link"
        disabled={isLoading}
      >
        {t("authentication_app.shared_links.resent_otp_code.link")}
      </Button>
    </BaseRedirectLinkContainer>
  );
};
